import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalComponent } from '../../core/shared/modal/modal.component';
import { UserDetailsRest } from '../../company/users/user-details/user-details.rest';
import { User } from '../../company/users/users.model';
import { LoginRest } from '../../login/login.rest';
import { ShellRestService } from '../shell.rest';
import { ProfilePictureService } from '../../profile-picture/profile-picture.service';

@Component({
  selector: 'app-profile-picture-selection',
  templateUrl: './profile-picture-selection.component.html',
  styleUrls: ['./profile-picture-selection.component.scss']
})
export class ProfilePictureSelectionComponent implements OnInit {

  @ViewChild('pictureSelectionForm') pictureSelectionForm: NgForm;
  @ViewChild(ModalComponent) private modal: ModalComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  private picture: string;
  private user: User;
  public selectedFile: string = 'Nie wybrano pliku';

  constructor(
    private loginRest: LoginRest,
    private rest: ShellRestService,
    private profilePictureService: ProfilePictureService
  ) {

  }

  ngOnInit() {
    this.modal.title = 'Edytuj zdjęcie profilowe';
  }

  public editProfilePicture() {
    this.loginRest.GetLoggedUser().subscribe(user => {
      this.user = user;
      this.picture = this.user.picture;
      this.modal.openWithCustomSize({ maxwidth: "550px" });
    });
  }

  private confirm() {
    this.updateProfilePicture();
    this.closeModal();
  }

  private removePicture() {
    this.picture = null;
    this.selectedFile = 'Nie wybrano pliku';
  }

  private closeModal() {
    this.modal.close();
  }

  private onModalClose() {
    this.picture = null;
    this.selectedFile = 'Nie wybrano pliku';
  }

  public onFileChanged(files: any[]) {
    if (!files || files.length === 0)
      return;

    var reader = new FileReader();
    if ((files[0] as File).size > 1048576) {
      sweetAlert("Wielkość pliku nie może przekraczać 1 MB")
      return;
    }
    reader.readAsArrayBuffer(files[0]);
    reader.onload = () => {
      let binaryString = '';
      let arrayBuffer = reader.result;
      let array = new Uint8Array(arrayBuffer);
      for (var i = 0; i < array.byteLength; i++) {
        binaryString += String.fromCharCode(array[i]);
      }
      this.picture = window.btoa(binaryString);
      this.selectedFile = files[0].name;
    }
  }

  private updateProfilePicture() {
    let data = { userId: this.user.id, picture: this.picture };
    this.rest.PostUserPicture(data).subscribe(() => {
      sweetAlert({ text: "Zmieniono zdjęcie profilowe" });
    });
    this.profilePictureService.changePicture(this.picture);
  }
}
